
import MultiClamp from 'multi-clamp'


const {CustomEvent, HTMLElement} = window

// TODO: need a ClampManager
// (because Clamp was one instance of one HTMLElement
// and Manager can store the clamped elements (necessary?) and instanciate it !)


export class Clamp {
  // DEFAULTS = {
  //   clampLine: 1
  // }


  /**
   * constructor
   * @param {HTMLElement} target the dom node on which we instanciate the class
   * @param {object}      options all the options to initialise the class instance
   * @throws {Error}
   */
  constructor (target) {
    if (target instanceof HTMLElement === false) {
      throw new Error('Impossible to attach clamp on no HTMLElement')
    }
    // @type {HTMLElement}
    this.element = target

    new MultiClamp(this.element, {
      ellipsis: '...',
      // TODO: default clampLine
      clamp: this.element.dataset.clampLine,
      onClampEnd: this.onClampEnd.bind(this)
    })
    /* eslint-enable no-new, no-undef */
  }


  /**
   * Launched when clamp process is finish
   */
  onClampEnd () {
    let endClampEvent
    if (typeof CustomEvent === 'function') {
      endClampEvent = new CustomEvent('end.clamp')
    } else {
      endClampEvent = document.createEvent('Event')
      endClampEvent.initEvent('end.clamp', true, true)
    }
    this.element.dispatchEvent(endClampEvent)
  }
}


/**
 * @param {string} [selector='[data-clamp-line]'] query string selector (like CSS selector)
 */
export function attachClampByQuery (selector = '[data-clamp-line]') {
  document.querySelectorAll(selector).forEach(elmt => new Clamp(elmt))
}
